import React from 'react';

import {Skeleton} from 'src/components/skeleton';

import Button from '@pb/kit-component-button';
import {Popover} from '@pb/kit-component-dropdown';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';


import {DefaultLimitsPopoverContent} from './default-limit-popover-content';
import {ResetLimitsSkeleton} from './reset-default-limits.skeleton';

import type {Limit} from 'src/openapi/admin/models/Limit';

type Props = {
    licenseLink?: React.ReactNode,
    defaultsLabel?: React.ReactNode,
    defaultLimitsContent?: React.ReactNode,
    isDefaultUsageLimits: boolean,
    loading: boolean,
    defaultUsageLimits: Array<Limit> | null,
    disabled?: boolean,
    onReset: () => void,
};

export const ResetUserDefaultLimits = (props: Props) => {
    const {isDefaultUsageLimits, defaultUsageLimits, loading, onReset, disabled, licenseLink} = props;

    const {defaultsLabel, defaultLimitsContent} = props;
    const description = defaultsLabel || (licenseLink ? <>the {licenseLink} license</> : null);

    return (
        <Skeleton view={<ResetLimitsSkeleton/>} shown={loading || !description}>
            <Group>
                <Button
                    variant="Type.SECONDARY"
                    disabled={disabled || isDefaultUsageLimits}
                    onClick={onReset}>
                    Use default limits
                </Button>
                {isDefaultUsageLimits ? (
                    <div>Currently using default limits for {description}.</div>
                ) : (
                    <div>
                        <b>Currently using custom limits.</b> Reset to defaults for {description}.&nbsp;
                        <Popover
                            anchor={({anchorRef, getAnchorProps}) => (
                                <span ref={anchorRef} {...getAnchorProps()}>
                                    <Icon type={Icons.INFO}/>
                                </span>
                            )}>
                            {defaultLimitsContent || (
                                <DefaultLimitsPopoverContent {...{description: licenseLink, defaultUsageLimits}}/>
                            )}
                        </Popover>
                    </div>
                )}
            </Group>
        </Skeleton>
    );
};
